<template>
  <section>
    <section class="top">
      <div class="container">
        <div class="row">
          <div class="col py-2">
            <div class="d-flex justify-content-end">
              <div>
                <div class="question">
                  Une question ?
                  <strong
                    ><a href="tel:+33493333887" style="color: #ffffff;"
                      >04 93 33 38 87</a
                    ></strong
                  >
                  nous serons ravis de vous conseiller
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="header">
      <div class="container">
        <div class="row p-3">
          <div class="col d-flex flex-column justify-content-center">
            <h1>Convaincu par Emotivi ?</h1>
            <h2 style="color:#159bac;">Passez à l'émotion grand format</h2>
            <h3 class="mb-4">
              Avec le crédit d'impôt, Emotivi c'est seulement<br /><strong
                >15 €/mois</strong
              >
              <span class="minus">
                ou 30€/mois sans aide
                <!-- <a href="#">vérifier mon éligibilité</a> -->
              </span>
            </h3>
            <div>
              <strong>Essayez gratuitement Emotivi pendant 1 mois !</strong>
            </div>
            <div>
              Vous n'avez que la caution du kit à avancer qui vous sera
              remboursée dès retour de votre kit.
            </div>
          </div>
          <div class="col-md-4">
            <img
              src="/images/visioconference-seniors.png"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <div
      class="container pb-1"
      style="background-color: #6ccdb2"
      id="page_subscription"
    >
      <div class="row mb-5">
        <div class="col">
          <div class="row align-items-end">
            <div class="col-md-12 col-lg-4 pt-4">
              <div class="mb-3">
                <img
                  src="/images/ico-interface.png"
                  alt=""
                  style="width: 70px"
                />
              </div>
              <div>
                <h2>COMMANDER<br />VOTRE KIT EMOTIVI</h2>
              </div>
            </div>

            <div
              class="
                offset-lg-2
                col-4 col-sm-4 col-lg-2
                text-center
                align-items-end
                d-flex
                justify-content-center
                mb-3
                mt-5
              "
            >
              <div>
                <h3
                  :class="{
                    'mb-3': true,
                    'part-subtitle': true,
                    over: part == 'part1'
                  }"
                >
                  1
                </h3>
                <h4
                  :class="{
                    small: screenWidth < 576,
                    'part-subtitle': true,
                    over: part == 'part1'
                  }"
                >
                  VOTRE<br />COMPTE
                </h4>
              </div>
            </div>
            <div
              class="
                col-4 col-sm-4 col-lg-2
                text-center
                align-items-end
                d-flex
                justify-content-center
                mb-3
              "
            >
              <div id="contact_selected">
                <h3
                  :class="{
                    'mb-3': true,
                    'part-subtitle': true,
                    over: part == 'part2'
                  }"
                >
                  2
                </h3>
                <h4
                  :class="{
                    small: screenWidth < 576,
                    'part-subtitle': true,
                    over: part == 'part2'
                  }"
                >
                  VOS<br />COORDONNEES
                </h4>
              </div>
            </div>
            <div
              class="
                col-4 col-sm-4 col-lg-2
                text-center
                align-items-end
                d-flex
                justify-content-center
                mb-3
              "
            >
              <div id="confirm_selected">
                <h3
                  :class="{
                    'mb-3': true,
                    'part-subtitle': true,
                    over: part == 'part3'
                  }"
                >
                  3
                </h3>
                <h4
                  :class="{
                    small: screenWidth < 576,
                    'part-subtitle': true,
                    over: part == 'part3'
                  }"
                >
                  CONFIRMATION<br />DES DONNEES
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ACCOUNT TILE -->
      <div style="display: block" v-if="part == 'part1'">
        <div>
          <h5 style="max-width: 600px">
            Créez votre compte qui vous permettra de recevoir votre kit EMOTIVI,
            gérer votre abonnement et gérer vos options
          </h5>
        </div>
        <form name="account" id="form_account">
          <div class="row mt-3">
            <div class="col-md-4">
              <div class="form-group">
                <label for="co_email_family">VOTRE EMAIL</label>
                <input
                  type="email"
                  class="form-control"
                  id="co_login"
                  name="co_login"
                  v-model="co_login"
                  style="border: none; border-radius: 0"
                />
              </div>
              <div class="form-group">
                <label for="co_password1">VOTRE MOT DE PASSE</label>
                <input
                  type="password"
                  class="form-control"
                  id="co_password1"
                  name="co_password"
                  v-model="co_password1"
                  style="border: none; border-radius: 0"
                />
              </div>
              <div class="form-group">
                <label for="co_password2">CONFIRMEZ VOTRE MOT DE PASSE</label>
                <input
                  type="password"
                  class="form-control"
                  id="co_password2"
                  v-model="co_password2"
                  style="border: none; border-radius: 0"
                />
              </div>
              <div v-if="dialogErrTxt" class="alert alert-danger">
                {{ dialogErrTxt }}
              </div>
              <button
                class="btn btn-primary"
                type="button"
                id="btstep1"
                @click="post_step1"
              >
                ETAPE SUIVANTE
              </button>
            </div>
            <div class="col-md-9">
              <p id="email_already_exist" style="color: #a4145a"></p>
            </div>
          </div>
        </form>
      </div>

      <!-- CONTACT TILE -->
      <div style="display: block" v-if="part == 'part2'">
        <form-contact :row_co="row_co" @checkphone="checkPhone"></form-contact>
        <div class="row mt-4 mb-5">
          <div class="col-md-4">
            <div v-if="dialogErrTxt" class="alert alert-danger">
              {{ dialogErrTxt }}
            </div>
            <button type="button" class="btn btn-primary" @click="post_step2">
              ETAPE SUIVANTE</button
            ><br /><br />

            <button
              v-show="$store.state.co_webaccesstoken_temp"
              type="button"
              class="btn btn-danger"
              @click="resetLocalStorage()"
            >
              RECOMMENCER MON INSCRIPTION
            </button>
          </div>
          <div class="col-md-9 align-items-end d-flex justify-content-start">
            <p id="error_msg_contact" style="color: #a4145a"></p>
          </div>
        </div>
      </div>

      <div id="sante_form" style="display: block" v-if="part == 'part4'">
        <div class="row text-left">
          <div class="col-md">
            <div class="row text-center">
              <div class="col">
                <h2>IMPORTANT</h2>
              </div>
            </div>
            <hr />
            <h4>
              Vous souhaitez installer le kit Emotivi dans un établissement de
              santé (Ehpad, maison de retraite) pour votre sénior ?
            </h4>
            <p>
              L'installation dans un établissement de santé est plus complexe
              qu'une installation chez un particulier car il faut des
              autorisations accordées par l'établissement.
            </p>
            <p>
              Merci de demander au responsable de l’établissement de santé de
              nous contacter par email (contact@emotivi.io) en précisant : le
              nom et l’adresse de l’établissement, le nom du directeur ou
              responsable, son numéro de téléphone et le nom de votre sénior.
            </p>
            <br /><br /><br /><br />
            <button type="button" class="btn btn-primary" @click="get_step3">
              ETAPE SUIVANTE
            </button>
          </div>
        </div>
      </div>

      <!-- CONFIRM TILE -->
      <div style="display: block" v-if="part == 'part3'">
        <div class="row text-left">
          <div class="col-md">
            <div class="row text-center">
              <div class="col">
                <h2>CONFIRMATION</h2>
              </div>
            </div>
            <hr />
            <h4 class="mb-0">
              Votre compte Emotivi a été créé avec succès.<br />
              <!-- Un mail vous a été envoyé sur votre adresse email pour activer le compte. -->
            </h4>

            <!-- <div style="float:right;">
            <button type="button" class="btn-next"
              style="width:auto; background-color:lightgray;" onclick="switchForm('contact');">
              Modifier les coordonnées
            </button>
          </div> -->
            <h4>Voici un récapitulatif de vos informations :</h4>
            <div class="row">
              <div class="col">
                <h5>
                  Adresse de facturation
                  <span v-if="!row_co.co_adresses_different">
                    et de livraison</span
                  >
                </h5>
                Votre prénom : {{ row_co.co_invoice_firstname }}<br />
                Votre nom : {{ row_co.co_invoice_name }}<br />
                Votre téléphone : {{ row_co.co_invoice_tel }}<br />
                Votre adresse :<br />
                <span v-html="adressfacturation"></span>
              </div>
              <div
                class="col"
                id="confirm_livraison"
                v-if="row_co.co_adresses_different"
              >
                <h5>Adresse de livraison</h5>
                Prénom livraison : {{ row_co.co_shipping_firstname }}<br />
                Nom livraison : {{ row_co.co_shipping_name }}<br />
                Téléphone livraison : {{ row_co.co_shipping_tel }}<br />
                Adresse livraison :<br />
                <span v-html="adresslivraison"></span>
              </div>
            </div>
            <a href="#" @click="get_step2" style="text-transform: none"
              >Modifier les coordonnées</a
            >
            <hr />
            <div id="recapChart" style="display: block" class="row"></div>
            <div></div>
            <div class="row mt-4 mb-5">
              <div class="col">
                <!-- <p>Premier paiement de 90€ incluant la location du boitier pour une période de 4 mois dont 1 mois
                offert et les frais de port.<br>La période de
                location commencera dès votre première connexion.</p>
              <p>Après 4 mois d'utilisation, vous serez débité mensuellement de 29,99€/mois. Résiliable à tout moment
                passé ce délai.</p> -->

                <!-- <p>Premier paiement de 99€ incluant :
                <ul>
                  <li>La location du kit Emotivi (boitier+camera+bouton+cables) pour une période de 4 mois (dont 1
                    mois offert)
                    soit 3x30€</li>
                  <li>Les frais de port</li>
                  <li>Si vous n’êtes pas satisfaits durant les 14 premiers jours suivant la réception du kit Emotivi,
                    vous serez remboursé intégralement après nous avoir retourné le matériel</li>
                </ul>
              </p> -->

                <div class="">
                  <input
                    type="checkbox"
                    class=""
                    id="cguid"
                    style="margin-top: -10px; width: auto; height: auto"
                    @change="cguAccept"
                  />&nbsp;
                  <label class="mb-0" for="cguid" style="font-size: 1rem">
                    J'accepte les CGU
                  </label>
                  <div class="mt-0">
                    <a
                      class="ml-4 small-text pointer"
                      href="/files/CGU-Emotivi-20201209.pdf"
                      >Voir les CGU</a
                    >
                  </div>
                </div>

                <br />

                <button
                  type="button"
                  class="btn btn-primary"
                  style="width: auto"
                  id="btnpay"
                  :disabled="!cguAccepted"
                  @click="post_step3"
                >
                  PROCÉDER AU PAIEMENT DE LA CAUTION -
                  {{ subscriptionAmount / 100 }} €
                </button>
                <br /><br />
                <div class="alert alert-info col-7">
                  <p v-if="row_co.co_box_connection_type === 'CLE4G_EMOTIVI'">
                    Le paiement de 60€ correspond à l'achat de la clé 4G.
                  </p>
                  <p
                    v-html="$options.filters.nl2br(offer.of_web_description)"
                  ></p>
                  <p>
                    Vous trouverez les tarifs des composants du kit Emotivi en
                    cas de perte ou détérioration en cliquant sur ce
                    <a
                      :href="
                        `${$config.server_url}/files/btoc/emotivi-tarifs-composants.pdf`
                      "
                      target="_blank"
                      >lien</a
                    >
                  </p>
                </div>
                <!-- Le paiement de 100€ correspond à la caution pour le kit
                  Emotivi
                  <br />Cette somme vous sera remboursé au retour du kit.<br />
                  L'abonnement de 30€ débutera lorsque le kit sera installé et
                  fonctionnel. -->

                <br /><br />
                <!-- <p class="">
                  Attention, dû à l'actualité de la covid-19 qui touche
                  également nos fournisseurs les délais de livraison peuvent
                  être rallongés jusqu'à 2 semaines
                </p> -->
                <p></p>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <section class="footer">
      <div class="container">
        <div class="row p-3">
          <div class="col-6 col-md-4">
            <h5>Adresse</h5>
            LA.TEAM - Emotivi<br />
            « Le Thélème »<br />
            1501, route des Dolines<br />
            06560 Valbonne<br />

            <h5 class="mt-4">Pour les professionnels</h5>
            pro@emotivi.fr<br />
            Tél. :
            <a href="tel:+33423360314" style="color: #ffffff;"
              >04 23 36 03 14</a
            >
            <br />
            Du lundi au vendredi<br />
            Horaires : 9h - 18h<br />
          </div>
          <div class="col-6 col-md-4">
            <h5>Contact commercial</h5>
            contact@emotivi.fr<br />
            Tél. :
            <a href="tel:+33493333887" style="color: #ffffff;">04 93 33 38 87</a
            ><br />
            Du lundi au vendredi<br />
            Horaires : 9h - 18h<br />

            <h5 class="mt-4">Contact technique</h5>
            support@emotivi.fr<br />
            Tél. :
            <a href="tel:+33754354703" style="color: #ffffff;">07 54 35 47 03</a
            ><br />
            Du lundi au vendredi<br />
            Horaires : 9h - 18h<br />
          </div>
          <div class="col-12 col-md-4">
            <div class="d-flex justify-content-between flex-wrap p-3">
              <div class="me-3">
                <img
                  src="/images/logo-bpi.png"
                  class="img-fluid"
                  style="max-width: 150px;"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/images/logo-ue-region.png"
                  class="img-fluid"
                  style="max-width: 150px;"
                  alt=""
                />
              </div>
            </div>
            <h5 class="mt-5">Légales</h5>

            <a
              style="color:white"
              href="https://emotivi.fr/mentions-legales-et-politique-de-confidentialite.html"
              target="_blank"
              >Mentions légales & Politique de confidentialité</a
            ><br />
            <a
              style="color:white"
              href="https://emotivi.fr/cookies.html"
              target="_blank"
              >Cookies</a
            ><br />
            <a
              style="color:white"
              href="https://emotivi.fr/images/CGU-Emotivi-20201209.pdf"
              target="_blank"
              >CGU</a
            ><br />
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import FormContact from "./FormContact";
import { loadStripe } from "@stripe/stripe-js";

// Vue.component("v-select", vSelect);

export default {
  name: "account",

  components: { FormContact },
  data() {
    return {
      subscriptionAmount: 0,
      shippingPhoneCheck: false,
      billingPhoneCheck: false,
      dialogErrTxt: "",
      cguAccepted: false,
      part: "part1",
      co_login: "",
      co_password1: "",
      co_password2: "",
      row_co: {},
      endusers: [],
      parcels: [],
      offer: {},
      offerproduct: {},
      screenWidth: window.innerWidth
    };
  },
  mounted() {
    if (this.$store.state.authenticated) {
      this.$store.commit("set_authentification", {
        accesstoken: "",
        affiliatedUser: {
          us_id: "",
          us_login: ""
        }
      });
    }
    if (this.$store.state.co_webaccesstoken_temp) {
      this.get_step2();
    }
    if (this.$route.query.part && this.$route.query.part === "part3") {
      this.get_step3();
    }
  },
  created() {
    window.addEventListener("resize", this.getScreenSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.getScreenSize);
  },
  computed: {
    adresslivraison() {
      let ad = "";
      ad += this.row_co.co_shipping_address1 + "<br>";
      if (this.row_co.co_shipping_address2)
        ad += this.row_co.co_shipping_address2 + "<br>";
      ad +=
        this.row_co.co_shipping_zip +
        " " +
        this.row_co.co_shipping_city +
        " - " +
        this.row_co.co_shipping_country +
        "<br>";
      return ad;
    },
    adressfacturation() {
      let ad = "";
      ad += this.row_co.co_invoice_address1 + "<br>";
      if (this.row_co.co_invoice_address2)
        ad += this.row_co.co_invoice_address2 + "<br>";
      ad +=
        this.row_co.co_invoice_zip +
        " " +
        this.row_co.co_invoice_city +
        " - " +
        this.row_co.co_invoice_country +
        "<br>";
      return ad;
    }
  },
  methods: {
    resetLocalStorage() {
      if (
        window.confirm(
          "Vous allez devoir créer un nouveau compte avec une nouvelle adresse Email. Souhaitez-vous continuer ??"
        )
      ) {
        this.$store.commit("set_co_webaccesstoken_temp", "");
        location.reload();
        // this.$router.push("/");
      }
    },
    cguAccept() {
      this.cguAccepted = !this.cguAccepted;
    },
    // openPdfCgu() {
    //   window.open(this.$config.server_url + "/web/2.0/cgu", "_blank");
    // },
    async post_step3() {
      let cguResponse = await this.$axios.post(
        this.$config.server_url + "/web/2.0/subscription/cgu",
        {
          co_webaccesstoken_temp: this.row_co.co_webaccesstoken_temp,
          co_cgu: "v2.1.5"
        }
      );

      if (!cguResponse.data.ok) return;

      let response = await this.$axios.post(
        this.$config.server_url + "/web/2.0/subscription/step3",
        { row_co: this.row_co, parcels: this.parcels, endusers: this.endusers }
      );

      // console.log("response.data", response.data);
      if (response.data.error) return this.$router.push("/fromstripe/ko");

      const stripe = await loadStripe(response.data.data.stripe_apikeypublic);
      stripe
        .redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: response.data.data.CHECKOUT_SESSION_ID
        })
        .then(function(result) {
          console.warn(result);
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          this.$router.push("/private/autolog/" + this.row_co.co_id + "/abcde");
        });
      // console.log("response.data", response.data);

      /*// autolog après paiement, avec challenge
      // @David je ne sais pas si c'est ici le bon endroit
      let challenge = md5(
        this.row_co.co_id + process.env.VUE_APP_CHALLENGE_KEY
      );
      console.log("challenge", challenge);
      this.$router.push(
        "/private/autolog/" + this.row_co.co_id + "/" + challenge
      ); */
      // http://localhost:4018/fromstripe/ok/cs_test_a13nXgrk9Q0yYLTZak0CukwxFsa6fzH5unc0ZgLvQA0mgDxtY3WiAsKsUa
    },
    async post_step2() {
      this.dialogErrTxt = "";
      // verifier les champs type de connexion et établissement
      if (!this.row_co.co_box_connection_type)
        this.dialogErrTxt = "Type de connexion à internet obligatoire";
      if (
        !this.row_co.co_box_tvbrand ||
        (this.row_co.co_box_tvbrand == "other" &&
          this.row_co.co_box_tvbrand_other == "")
      )
        this.dialogErrTxt = "Marque de votre télévision obligatoire";
      if (this.row_co.co_invoice_civility == "")
        this.dialogErrTxt = "Veuillez sélectionner votre civilité.";
      if (!this.row_co.co_box_inestablishment)
        this.dialogErrTxt =
          "Est-ce que le kit Emotivi sera installé dans un Établissement de santé, champ obligatoire";
      if (!this.row_co.co_invoice_name)
        this.dialogErrTxt = "Veuillez renseigner votre nom.";
      if (!this.row_co.co_invoice_firstname)
        this.dialogErrTxt = "Veuillez renseigner votre prénom.";
      if (
        !this.row_co.co_invoice_address1 ||
        !this.row_co.co_invoice_zip ||
        !this.row_co.co_invoice_country ||
        !this.row_co.co_invoice_city
      )
        this.dialogErrTxt = "Veuillez renseigner votre adresse complète.";

      // Vérif téléphone
      if (!this.row_co.co_invoice_tel)
        this.dialogErrTxt = "Veuillez renseigner un numéro de téléphone";
      else if (this.row_co.co_invoice_tel && !this.billingPhoneCheck)
        this.dialogErrTxt = "Veuillez renseigner un numéro de téléphone valide";
      else if (this.row_co.co_shipping_tel && !this.shippingPhoneCheck)
        this.dialogErrTxt =
          "Veuillez renseigner un numéro de téléphone de livraison valide";

      if (this.dialogErrTxt) return;
      // let response =
      // let parcel = { pa_id: this.parcels.length ? this.parcels[0].pa_id : "" };
      // let enduser = {
      //   en_id: this.endusers.length ? this.endusers[0].en_id : "",
      //   en_fullname:
      //     this.row_co.co_invoice_name + " " + this.row_co.co_invoice_firstname
      // };
      // let tabFields = [
      //   "civility",
      //   "name",
      //   "firstname",
      //   "address1",
      //   "address2",
      //   "zip",
      //   "city",
      //   "country",
      //   "tel"
      // ];
      // for (let iField = 0; iField < tabFields.length; iField++) {
      //   const field = tabFields[iField];
      //   if (this.row_co.co_adresses_different)
      //     parcel["pa_shipping_" + field] = this.row_co["co_shipping_" + field];
      //   else
      //     parcel["pa_shipping_" + field] = this.row_co["co_invoice_" + field];
      // }
      // this.endusers = [enduser];
      // this.parcels = [parcel];
      // console.log("this.endusers,this.parcels", this.endusers, this.parcels);
      let response = await this.$axios.post(
        this.$config.server_url + "/web/2.0/subscription/step2",
        { row_co: this.row_co } //, parcels: this.parcels, endusers: this.endusers
      );
      if (response.data.err) {
        console.warn("errrr ::", response.data.err);
        if (response.data.err.key == "name_mandatory")
          this.dialogErrTxt = "Nom et prénom obligatoire";
        else if (response.data.err.key == "address_mandatory")
          this.dialogErrTxt = "Adresse, code postal et ville obligatoire";
        else if (response.data.err.key == "shipping_address_mandatory")
          this.dialogErrTxt =
            "Adresse, code postal et ville de livraison obligatoire";
        else this.dialogErrTxt = response.data.err.message;
        return;
      }
      if (this.row_co.co_box_inestablishment == "yes") this.get_step4();
      else this.get_step3();
    },
    async get_step4() {
      this.part = "part4";
    },
    async get_step3() {
      let response = await this.$axios.get(
        this.$config.server_url + "/web/2.0/subscription/step3",
        {
          params: {
            co_webaccesstoken_temp: this.$store.state.co_webaccesstoken_temp
          }
        }
      );
      //console.log("response.data.data", response.data.data);
      this.row_co = response.data.data;
      this.parcels = response.data.parcels;
      this.endusers = response.data.endusers;
      this.offer = response.data.offer;
      this.offerproduct = response.data.offerproduct;

      this.subscriptionAmount = this.offerproduct.ofpr_initial_price_ht;
      if (this.row_co.co_box_connection_type === "CLE4G_EMOTIVI") {
        this.subscriptionAmount += 6000;
      }
      // console.log("offer, offerproduct", this.offer, this.offerproduct);
      this.part = "part3";
      this.toTop();
    },
    toTop() {
      document.getElementById("page_subscription").scrollIntoView();
    },
    async get_step2() {
      let response = await this.$axios.get(
        this.$config.server_url + "/web/2.0/subscription/step2",
        {
          params: {
            co_webaccesstoken_temp: this.$store.state.co_webaccesstoken_temp
          }
        }
      );
      // console.log("response.data.data", response.data.data);
      this.row_co = response.data.data;
      this.parcels = response.data.parcels;
      this.endusers = response.data.endusers;
      this.part = "part2";
      this.toTop();
    },
    async post_step1() {
      this.dialogErrTxt = "";
      if (this.co_password1 != this.co_password2) {
        this.dialogErrTxt = "Les mots de passe doivent être identique";
        return;
      }
      let response = await this.$axios.post(
        this.$config.server_url + "/web/2.0/subscription/step1",
        {
          co_login: this.co_login,
          co_password: this.co_password1
        },
        {
          headers: {
            // "x-auth-accesstoken": this.$store.state.user.co_accesstoken
          }
        }
      );
      // console.log("response.data.data", response.data);
      if (response.data.err) {
        if (response.data.err.key == "login_mandatory")
          this.dialogErrTxt = "Identifiant obligatoire";
        else if (response.data.err.key == "password_mandatory")
          this.dialogErrTxt = "Mot de passe obligatoire";
        else if (response.data.err.key == "email_format_error")
          this.dialogErrTxt = "Format d'email non valide";
        else if (response.data.err.key == "user_login_exists_already")
          this.dialogErrTxt = "Votre identifiant existe déjà";
        else if (response.data.err.key == "password_format_error")
          this.dialogErrTxt =
            "Le mot de passe nécessite au moins 8 caractères, une minuscule, une majuscule et un chiffre";
        else this.dialogErrTxt = response.data.err.message;
        return;
      }
      this.$store.commit(
        "set_co_webaccesstoken_temp",
        response.data.data.co_webaccesstoken_temp
      );
      this.get_step2();
      // response.data.data.
    },
    checkPhone(valide, co_phoneField) {
      if (co_phoneField === "co_shipping_tel") {
        this.shippingPhoneCheck = valide;
      } else if (co_phoneField === "co_invoice_tel") {
        this.billingPhoneCheck = valide;
      }
      //console.log("SUBSCRIPTION :", co_phoneField, valide);
    },
    getScreenSize(event) {
      this.screenWidth = event.target.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  padding-bottom: 50px;
  // padding-top: 40px;
}
section.header {
  //background-color: #b8e0e3;
  // box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  // margin-bottom: 3rem;
  padding-bottom: 0px;
}
section.header .container {
  background-color: #b8e0e3;
}
section.footer {
  //margin-top: 50px;
  //background-color: #5397a5;
  color: white;
  // padding-top: 2rem;
  // padding-bottom: 2rem;
}
section.footer .container {
  background-color: #5397a5;
}
section.footer h5 {
  font-weight: bold;
}
section.top {
  padding-bottom: 0px;
}
.question {
  background-color: rgba(165, 26, 91, 1);
  border-radius: 5px;
  color: white;
  padding: 6px 10px;
  margin-top: 10px;
  line-height: 1.1rem;
  font-size: 1rem;
  animation: 1s ease-in 0s infinite alternate slidein;
}

@keyframes slidein {
  from {
    background-color: rgba(165, 26, 91, 0.5);
  }

  to {
    background-color: rgba(165, 26, 91, 1);
  }
}
</style>
